import { createContext, useContext } from 'react'

import { ucscThemeStyle } from '@/design-lib/style-theme/tenant/ucscTheme.css'
import { TENANTS } from '@/lib/tenants/constants'
import { Tenants } from '@/lib/tenants/types'

type TenantContextData = { tenant: Tenants }

const TenantContext = createContext<TenantContextData>({ tenant: TENANTS.casavo })

export const TenantContextProvider: React.FC<TenantContextData> = ({ children, tenant }) => {
  return (
    <TenantContext.Provider value={{ tenant }}>
      <div style={tenant === TENANTS.ucsc ? ucscThemeStyle : undefined}>{children}</div>
    </TenantContext.Provider>
  )
}

export const useCurrentTenant = () => {
  return useContext(TenantContext).tenant
}
